'use strict';

wbApp.factory('courseTypeImageSvc', ['$resource', '$cacheFactory', 'repositorySvc', 
    function ($resource, $cacheFactory, repositorySvc) {

        var CourseTypeImage = $resource('/restapi/icons', {}, {
            'getAll': { method: 'GET', isArray: true, url: '/restapi/icons' }
        });

        var cache = $cacheFactory('courseTypeImageSvcCache');

        function getAllAsync(refresh) {

            var models = cache.get('courseTypeImages');

            if (refresh || !models) {
                if (models) {
                    cache.remove('courseTypeImages');
                }

                models = repositorySvc.customGet('getAll', CourseTypeImage);
                cache.put('courseTypeImages', models);
            }

            return models;
        }

        return {
            getAllAsync: getAllAsync
        }
    }
]);
